import { render, staticRenderFns } from "./SlideNotes.vue?vue&type=template&id=30e12380"
import script from "./SlideNotes.vue?vue&type=script&lang=js"
export * from "./SlideNotes.vue?vue&type=script&lang=js"
import style0 from "./SlideNotes.vue?vue&type=style&index=0&id=30e12380&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports